/* global google */

class ResetPasswordController {
    /**
     * @param authService
     */
    constructor($window, $location, $state, authService) {
        if(localStorage.getItem('kes_token')) {
            localStorage.removeItem('kes_email');
            localStorage.removeItem('kes_token');
            $window.location.reload();
        }
        this.$location = $location;
        this.$state = $state;
        this.authService = authService;
        this.token = $location.search().token;
        this.loaded = false;
        this.valid = null;
        this.credentials = {
            token: this.token
        }
    }

    $onInit() {
        this.authService.init(google);
        this.authService.checkToken(this.token).then(() => this.valid = true, () => this.valid = false).finally(() => this.loaded = true);
    }

    onRegisterButtonClick() {
        this.authService.changePassword(this.credentials).then(() =>
            this.$location.path('/login?accepted=true')
        );
    }
}

ResetPasswordController.$inject = ['$window', '$location', '$state', 'AuthService'];

export default ResetPasswordController;



// WEBPACK FOOTER //
// ./src/app/pages/login/resetPassword/resetPasswordController.js